import React, { useEffect, useState } from 'react'
import { Button, Grid, List, ListItem, ListItemText, TextField, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import i18next from 'i18next';
import FormQuestions from './components/FormQuestions';
import { postApi } from './api/services';
import { serviceDown } from './utils/UtilityFunctions';
import MainLoader from './components/MainLoader';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import swal from 'sweetalert';

const Order = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [formulation, setFormulation] = useState('');
  const [seeMore, setSeeMore] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [address, setAddress] = useState({})

  const formulationsList = [
    { 
      name: "Dutasteride: 1mg/ml(60mg)", 
      value: "Dutasteride: 1mg/ml(60mg)", 
      bottle: "One - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 1mg/ml(60mg total)",
      identifier: 'bottle'
    },
    { 
      name: "Dutasteride: 2mg/ml (120mg)", 
      value: "Dutasteride: 2mg/ml (120mg)", 
      bottle: "Two - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 2mg/ml (120mg total)",
      identifier: 'bottle'
    },
    { 
      name: "Dutasteride: 5mg/ml (300mg)", 
      value: "Dutasteride: 5mg/ml (300mg)", 
      bottle: "Five - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 5mg/ml (300mg total)",
      identifier: 'bottle'
    },
    { 
      name: "(foam)Dutasteride: 1mg/ml(60mg)", 
      value: "(foam)Dutasteride: 1mg/ml(60mg)",
      bottle: "One Foam - 60ml",
      detail: "Dutasteride: 1mg/ml(60mg total)",
      identifier: 'foam'
    },
    { 
      name: "(foam)Dutasteride: 2mg/ml (120mg)", 
      value: "(foam)Dutasteride: 2mg/ml (120mg)", 
      bottle: "Two Foam - 60ml",
      detail: "Dutasteride: 2mg/ml (120mg total)",
      identifier: 'foam'
    },
    { 
      name: "(foam)Dutasteride: 5mg/ml (300mg)", 
      value: "(foam)Dutasteride: 5mg/ml (300mg)",
      bottle: "Five Foam - 60ml",
      detail: "Dutasteride: 5mg/ml (300mg total)",
      identifier: 'foam'
    }
  ]

  const bottlePrescriptionDetails = [
    'Follicle Delivery System',
    'GHK-Cu (Copper Tripeptide-1)',
    'Acetyl Tetrapeptide-3',
    'Excipients Phenoxyethanol and Caprylyl Glycol',
    'Sterile water according to required final concentrations'
  ]

  const foamPrescriptionDetails = [
    'Follicle Delivery System',
    'GHK-Cu (Copper Tripeptide-1)',
    'Acetyl Tetrapeptide-3',
    'Dimethyl Sulfoxide (DMSO)',
    'Acrylates/C10-30 Alkyl Acrylate Crosspolymer (foam)',
    'Excipients Phenoxyethanol and Caprylyl Glycol',
    'Sterile water according to required final concentrations'
  ]

  useEffect(() => {
    let defaultAddress = {
      address: JSON.parse(localStorage.getItem('doctorobj'))?.address,
      city: JSON.parse(localStorage.getItem('doctorobj'))?.city,
      country: JSON.parse(localStorage.getItem('doctorobj'))?.country,
      postal_code: JSON.parse(localStorage.getItem('doctorobj'))?.postal_code,
    }
    // JSON.parse(localStorage.getItem('doctorobj'))?.clinic_address
    defaultAddress && setAddress(defaultAddress);
    if(location?.state?.prescribed_medicine){
      setFormulation(location.state.prescribed_medicine)
    } else {
      getPrescription()
    }
  }, [])

  const placeOrder = async () => {
    setEditAddress(false);
    console.log('Final Address:', address);
    setIsLoading(true)
    let docDetails = JSON.parse(localStorage.getItem('doctorobj'))
    let params = {
      email: docDetails.email,
      quantity: 1,
      user_id: location?.state?.user_obj?.user_id,
      doctor_id: docDetails.doctor_id
    }
    console.log("create_order params", params);
    try {
      let res = await postApi('create_order', params)
      if(res?.error) {
        setIsLoading(false)
        serviceDown(navigate)
      } else {
        setIsLoading(false)
        swal({
          title: i18next.t('Order placed successfully'),
          icon: 'success'
        }).then(() => {
          navigate(-1); 
        })
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown(navigate)
    }
  }

  const getPrescription = async () => {
    try {
      setIsLoading(true)
      let params = {
        user_id: location?.state?.user_obj?.user_id
      }
      console.log("get_user_prescriptions params", params);
      const res = await postApi('get_user_prescriptions', params)
      if(res){
        console.log("get_user_prescriptions res", res);
        setIsLoading(false)
        setFormulation(res?.prescriptions[0]?.prescribed_medicine)
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown(navigate, '/homepage')
    }
  }

  const renderPrescriptionDetails = () => {
    let bottleVal = formulationsList.find(o => o.value === formulation)?.bottle;
    let dutastrideDetail = formulationsList.find(o => o.value === formulation)?.detail;
    let identifier = formulationsList.find(o => o.value === formulation)?.identifier;
    return (
      <Grid container spacing={0} className='d-flex justify-content-start align-items-start'>
        <Grid item xs={12} className='d-flex justify-content-start align-items-start flex-direction-column'>
          <h3 className='mb-5px'>{i18next.t('Formulation Details:')}</h3>
          <p className='mb-0 text-left'>{i18next.t(`Compounded Hair Treatment ${bottleVal} `)}</p>
          <div className='d-flex justify-content-start align-items-center mt-10px' onClick={() => setSeeMore(!seeMore)}>
            <p className='seemore mb-0 cursor-pointer'>{i18next.t(!seeMore ? 'See More' : 'See Less')}</p>
            {!seeMore ? <ExpandMoreIcon className='expandicon'/> : <ExpandLessIcon className='expandicon'/>}
          </div>
            {
              seeMore && 
                <List className='presdetlist mb-5px' sx={{ listStyleType: 'disc', pl: 3, '& .MuiListItem-root': { display: 'list-item' } }}>
                  <ListItem>
                    <ListItemText>
                      {dutastrideDetail}
                    </ListItemText>
                  </ListItem>
                  {
                    identifier === 'bottle' ? 
                      bottlePrescriptionDetails.map((item, index) => (
                        <ListItem key={index}>
                          <ListItemText>
                            {item}
                          </ListItemText>
                        </ListItem>
                      ))
                        : 
                      foamPrescriptionDetails.map((item, index) => (
                        <ListItem key={index}>
                          <ListItemText>
                            {item}
                          </ListItemText>
                        </ListItem>
                      ))
                  }
                </List>
            }         
        </Grid>
      </Grid>  
    )
  }

  const addAddress = (value, identifier) => {
    setAddress(prev => ({
      ...prev,
      [identifier]: value,   // dynamically updates the correct key
    }));
  };

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='orderpage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate('/clients', { state: { goTo: location?.state?.from }})}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center '>
            <Typography variant="h6" className="title">{i18next.t("Order")}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid>
        </Grid>
        <div className='orderpage-questions-container'>
          <Grid container spacing={0} className='d-flex justify-content-start align-items-start mb-20px maincard'>
            <Grid item xs={12} className='d-flex justify-content-start align-items-start mb-20px'>
              <h2 className='text-left'>{i18next.t('Compounded Hair Treatment')}</h2>
            </Grid>
            <Grid item xs={12} className='d-flex justify-content-start align-items-start'>
              {renderPrescriptionDetails()}    
            </Grid>
          </Grid>
          <Grid container spacing={0} className='d-flex justify-content-start align-items-start mt-20px mb-20px maincard'>
            <Grid container spacing={0} className='d-flex justify-content-start align-items-start mb-20px'>
              <Grid item xs={11} className='d-flex justify-content-start align-items-start'>
                <h3 className='text-left'>{i18next.t('Shipping Address')}</h3>
              </Grid>
              {
                !editAddress && 
                  <Grid item xs={1} className='d-flex justify-content-end align-items-end' onClick={() => setEditAddress(!editAddress)}>
                    <EditIcon className='editicon cursor-pointer'/> 
                  </Grid>
              }
            </Grid>
            <Grid container spacing={0} className='d-flex justify-content-start align-items-start'>
              <Grid item xs={12} className='d-flex justify-content-start align-items-start flex-direction-column'>
                {
                  !editAddress ?
                    <>
                      <p className='mb-5px fw-600'>{i18next.t('Address')}</p>
                      <p className='text-left'>{address?.address}</p>
                      <p className='mb-5px fw-600'>{i18next.t('Postal code')}</p>
                      <p className='text-left'>{address?.postal_code}</p>
                      <p className='mb-5px fw-600'>{i18next.t('City')}</p>
                      <p className='text-left'>{address?.city}</p>
                      <p className='mb-5px fw-600'>{i18next.t('Country')}</p>
                      <p className='text-left mb-0'>{address?.country}</p>
                    </> 
                      :
                    <div className='editAddressDiv d-flex justify-content-start align-items-start flex-direction-column w-100'>
                      <p className=''>{i18next.t('Address')}</p>
                      <TextField
                        multiline
                        defaultValue={address?.address}
                        onChange={(e) => addAddress(e.target.value, 'address')}
                        placeholder={i18next.t('Enter Shipping Address')}
                        minRows={3}
                        inputProps={{ maxLength: 200 }}
                        className='mb-20px'
                      />
                      <p className=''>{i18next.t('Postal code')}</p>
                      <TextField
                        defaultValue={address?.postal_code}
                        onChange={(e) => addAddress(e.target.value, 'postal_code')}
                        placeholder={i18next.t('Enter Shipping Address')}
                        inputProps={{ maxLength: 200 }}
                        className='mb-20px'
                      />
                      <p className=''>{i18next.t('City')}</p>
                      <TextField
                        defaultValue={address?.city}
                        onChange={(e) => addAddress(e.target.value, 'city')}
                        placeholder={i18next.t('Enter Shipping Address')}
                        inputProps={{ maxLength: 200 }}
                        className='mb-20px'
                      />
                      <p className=''>{i18next.t('Country')}</p>
                      <TextField
                        defaultValue={address?.country}
                        onChange={(e) => addAddress(e.target.value, 'country')}
                        placeholder={i18next.t('Enter Shipping Address')}
                        inputProps={{ maxLength: 200 }}
                        className='mb-20px'
                      />
                      <Button className='commonButton saveaddress' onClick={() => setEditAddress(!editAddress)}>
                        {i18next.t('Save')}
                      </Button>
                    </div>
                }
              </Grid>
            </Grid>
          </Grid>
          <Button className='commonButton placeorderbtn mb-10px' onClick={() => placeOrder()}>
            {i18next.t('Place Order')}
          </Button>
        </div>
      </div>
    </>
  )
}

export default Order